export default __webpack_public_path__ + "static/media/icon-pathwayreport_support.e053fd2b.png";